import React from "react";
import style from "../Dialogs.module.css";
import Message from "./Message";


const Messages = (props) => {
    let newMessageBody = props.newMessageBody;


    let onSendMessageClick = () => {
        props.sendMessage(props.id);
    }
    let onNewMessageChange = (e) => {
        let body = e.target.value;
        props.updateNewMessageBody(body);
    }
    let messagesElement = props.messages.map(elem => <Message key = {elem.id} id= {elem.id} message = {elem.message} time = {elem.time} src = {elem.src} />);

    return(
        <div className={style.messagesBox}>
            {messagesElement}
            <textarea className={style.inputMessage}
                      onChange={onNewMessageChange}
                      placeholder='Type your message here'
                      value={newMessageBody}
                      cols="50" rows="2"></textarea>
            <button className={style.sendBtn} onClick={onSendMessageClick}>Send</button>

        </div>
    )
}
//
export default Messages;